import React from "react";
import { Button, Navbar, Nav, Form, FormControl } from "react-bootstrap";
import * as constants from "../../Constants";
import { Link } from "react-router-dom";

export default function MyNavbar() {
  return (
    <>
      <Navbar bg="dark" variant="dark">
        <Navbar.Brand as={Link} to={{ pathname: "/" }}>
          {constants.MainTitle}
        </Navbar.Brand>
        <Nav className="mr-auto">
          <Nav.Link as={Link} to={{ pathname: "/search" }}>
            Add new book
          </Nav.Link>
          <Nav.Link as={Link} to={{ pathname: "/about" }}>
            About
          </Nav.Link>
        </Nav>
        <Form inline style={{ display: "inline" }}>
          <FormControl type="text" placeholder="Search" className="mr-sm-2" />
          <Button variant="outline-info">Search</Button>
        </Form>
      </Navbar>
    </>
  );
}
